import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportRetentionsTypes } from "redux/reducers/Reports/reportRetentions/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_RETENTIONS_FILTERS } = reportRetentionsTypes;

export const getReportRetentionsAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/retentions?start=${startDate}&end=${endDate}&idStation=${station.id}&pdf=${isPdf}`;
    const fileName = `Reporte_Retenciones_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

    dispatch(startRequestComp('loadingRetentions'));
    try {
      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingRetentions'));
    }
  };
};

export const setReportRetentionsFilters = (key = "", value) => ({
  type: SET_RETENTIONS_FILTERS,
  payload: { key, value }
});
